<style></style>

<template>
    <div class="dropdown">
        <div class="trigger" 
            @click="showCollapsed = !showCollapsed"
            :class="showCollapsed ? null : 'collapsed'"
            role="tab"
        >
            <slot name="trigger"></slot>
        </div>        
        <slot name="between"></slot>
        <BCollapse v-model="showCollapsed" class="collapsed-content" :id="id" v-bind:accordion="accordion" role="tabpanel">
            <slot name="collapsed-content"></slot>
        </BCollapse>
    </div>
</template>

<script>
    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            }
        },
        components: {},
        data() {
            return {
                showCollapsed: false,
                id: 'dropdown-'+Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
            }
        },
        methods: {},
        mounted() {
            this.showCollapsed = this.visible;
        }
    
}
</script>